<template>
  <form name="permissions-info-model-form" @submit.prevent="$emit('save')">
    <BLayoutExpansion title="Основное" class="my-4">
      <v-row dense>
        <v-col sm="6" lg="3">
          <BTextField
            v-model="form.code"
            validate="required"
            label="Код"
            :disabled="isView"
            :skeleton="skeleton"
            name="code"
            autofocus
          />
        </v-col>

        <v-col sm="6" lg="5">
          <BTextField
            v-model="form.name"
            validate="required"
            label="Название"
            :disabled="isView"
            :skeleton="skeleton"
            name="name"
          />
        </v-col>
      </v-row>

      <v-row dense>
        <v-col sm="12" lg="6">
          <BAutocompleteCommon
            v-model="form.application"
            validate="required"
            $type="permission-application"
            :disabled="isView"
            :skeleton="skeleton"
            name="application_id"
          />
        </v-col>
      </v-row>

      <v-row v-if="!isCreate" dense>
        <v-col :cols="!skeleton && 'auto'">
          <BTextField
            :value="data.created_at | dateFormatter"
            :skeleton="skeleton"
            label="Создан"
            disabled
          />
        </v-col>

        <v-col :cols="!skeleton && 'auto'">
          <BTextField
            :value="data.updated_at | dateFormatter"
            :skeleton="skeleton"
            label="Обновлен"
            disabled
          />
        </v-col>
      </v-row>
    </BLayoutExpansion>

    <button type="submit" class="d-none" />
  </form>
</template>

<script>
import BLayoutForm from '@/components/layouts/BLayoutForm.vue'
import BLayoutExpansion from '@/components/layouts/BLayoutExpansion.vue'
import BTextField from '@/components/forms/BTextField.vue'
import BAutocompleteCommon from '@/components/forms/BAutocompleteCommon.vue'


const createDefaultData = () => ({
  // id
  code: '',
  // created_at
  name: '',
  // updated_at
})

export default {
  name: 'PermissionsInfoModelForm',
  components: {
    BLayoutExpansion,
    BTextField,
    BAutocompleteCommon,
  },
  extends: BLayoutForm,
  props: {
    skeleton: Boolean,
    data: {
      type: Object,
      required: true,
      default: createDefaultData,
    },
  },
  methods: {
    async onSubmit() {
      const result = await this.$validator.validate()

      if (!result) {
        this.$notice.validatorFormError(this)
        const message = `Error submit: ${this.$options.name}`
        const error = new Error(message)
        return Promise.reject(error)
      }

      const { form } = this

      const data = {
        ...form,

        application: void 0,
        application_id: form.application?.id ?? null,
      }

      this.$emit('submit', data)

      return data
    },
  },
}
</script>
